import React from 'react';
import { Layout, Row, Col, Typography, Button } from 'antd';
import { 
  LinkedinOutlined, 
  GithubOutlined, 
  MailOutlined,
  BookOutlined,
  ArrowUpOutlined
} from '@ant-design/icons';

const { Footer: AntFooter } = Layout;
const { Title, Paragraph, Text } = Typography;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const quickLinks = [
    { label: 'About', onClick: () => scrollToSection('about') },
    { label: 'Experience', onClick: () => scrollToSection('experience') },
    { label: 'Projects', onClick: () => scrollToSection('projects') },
    { label: 'Publications', onClick: () => scrollToSection('publications') },
    { label: 'Education', onClick: () => scrollToSection('education') },
    { label: 'News', onClick: () => scrollToSection('news') },
    { label: 'Contact', onClick: () => scrollToSection('contact') }
  ];

  return (
    <AntFooter style={{ 
      background: '#001529', 
      color: 'white',
      padding: '48px 24px 24px'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Row gutter={[32, 32]} style={{ marginBottom: '32px' }}>
          <Col xs={24} sm={12} md={8}>
            <div>
              <Title level={4} style={{ color: '#1890ff', marginBottom: '16px' }}>
                Katenda Enock
              </Title>
              <Paragraph style={{ color: '#bfbfbf', marginBottom: '8px' }}>
                Software Engineer | Systems Support Specialist | Graphics Designer
              </Paragraph>
              <Paragraph style={{ color: '#8c8c8c', marginBottom: '8px' }}>
                Building scalable solutions with passion and precision.
              </Paragraph>
              <Paragraph style={{ color: '#1890ff' }}>
                🌐 katendaenock.com
              </Paragraph>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={8}>
            <div>
              <Title level={5} style={{ color: 'white', marginBottom: '16px' }}>
                Quick Links
              </Title>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {quickLinks.map((link, index) => (
                  <Button
                    key={index}
                    type="link"
                    onClick={link.onClick}
                    style={{ 
                      color: '#bfbfbf',
                      padding: 0,
                      height: 'auto',
                      textAlign: 'left',
                      justifyContent: 'flex-start'
                    }}
                  >
                    {link.label}
                  </Button>
                ))}
              </div>
            </div>
          </Col>
          
          <Col xs={24} sm={12} md={8}>
            <div>
              <Title level={5} style={{ color: 'white', marginBottom: '16px' }}>
                Contact Info
              </Title>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <Text style={{ color: '#bfbfbf', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span>📍</span> New York, NY
                </Text>
                <Text style={{ color: '#bfbfbf', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span>📞</span> +1 347 399 8354
                </Text>
                <Text style={{ color: '#bfbfbf', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span>✉️</span> katendaenock@gmail.com
                </Text>
              </div>
            </div>
          </Col>
        </Row>
        
        <div style={{ 
          borderTop: '1px solid #434343', 
          paddingTop: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <Text style={{ color: '#8c8c8c' }}>
            &copy; {currentYear} Katenda Enock. All rights reserved.
          </Text>
          
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <div style={{ display: 'flex', gap: '8px' }}>
              <Button
                type="text"
                icon={<LinkedinOutlined />}
                href="https://linkedin.com/in/katenda-enock-349657143"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#bfbfbf' }}
              />
              <Button
                type="text"
                icon={<GithubOutlined />}
                href="https://github.com/katenda"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#bfbfbf' }}
              />
              <Button
                type="text"
                icon={<MailOutlined />}
                href="mailto:katendaenock@gmail.com"
                style={{ color: '#bfbfbf' }}
              />
              <Button
                type="text"
                icon={<BookOutlined />}
                href="https://scholar.google.com/citations?user=FMejVSsAAAAJ&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#bfbfbf' }}
              />
            </div>
            
            <Button
              type="text"
              icon={<ArrowUpOutlined />}
              onClick={scrollToTop}
              style={{ 
                color: '#bfbfbf',
                border: '1px solid #434343'
              }}
              title="Back to top"
            />
          </div>
        </div>
      </div>
    </AntFooter>
  );
};

export default Footer;